export const LOAD_PHYSIOTHERAPY_REFERRAL_REPORT = "LOAD_PHYSIOTHERAPY_REFERRAL_REPORT";

export const SAVE_PHYSIOTHERAPY_REFERRAL_REPORT = "SAVE_PHYSIOTHERAPY_REFERRAL_REPORT";
export const SAVE_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS = "SAVE_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS";

export const SUBMIT_PHYSIOTHERAPY_REFERRAL_REPORT = "SUBMIT_PHYSIOTHERAPY_REFERRAL_REPORT";
export const SUBMIT_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS = "SUBMIT_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS";

export const LOAD_CONSULTATION_AND_PHYSIOTHERAPY_REFERRAL_DETAILS = "LOAD_CONSULTATION_AND_PHYSIOTHERAPY_REFERRAL_DETAILS";

export const APPROVE_PHYSIOTHERAPY_REFERRAL_REPORT = "APPROVE_PHYSIOTHERAPY_REFERRAL_REPORT";
export const APPROVE_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS = "APPROVE_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS";

export const REQUEST_PHYSIOTHERAPY_CHANGES_REFERRAL_REPORT = "REQUEST_PHYSIOTHERAPY_CHANGES_REFERRAL_REPORT";
export const REQUEST_PHYSIOTHERAPY_CHANGES_REFERRAL_REPORT_SUCCESS = "REQUEST_PHYSIOTHERAPY_CHANGES_REFERRAL_REPORT_SUCCESS";

export const REJECT_PHYSIOTHERAPY_REFERRAL_REPORT = "REJECT_PHYSIOTHERAPY_REFERRAL_REPORT";
export const REJECT_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS = "REJECT_PHYSIOTHERAPY_REFERRAL_REPORT_SUCCESS";
